import { jsx, jsxs } from "react/jsx-runtime";
import { memo, useEffect, useLayoutEffect, useState } from "react";
import { DatePicker, Flex, Grid, theme } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "@inscore/shared";
import { ReactComponent as ArrowLeft } from "./../../../assets/icons/arrow-left.svg";
import { ReactComponent as ArrowRight } from "./../../../assets/icons/arrow-right.svg";
import { ReactComponent as Calendar } from "./../../../assets/icons/calendar.svg";
import { EVENT_ACTIONS, track } from "./../../../lib/gtag.js";
import "./matchesDatePicker.css";
const { useBreakpoint } = Grid;
const MatchesDatePicker = ({
  selectedDate,
  setSelectedDate,
  onLiveClick,
  live
}) => {
  const screens = useBreakpoint();
  const [calendarOpened, setCalendarOpened] = useState(false);
  const { token } = theme.useToken();
  const { t } = useTranslation();
  useLayoutEffect(() => {
    if (typeof document === "undefined")
      return;
    document.documentElement.style.setProperty(
      "--date-picker-mobile-width",
      "calc(100vw - 72px)"
    );
  }, []);
  useEffect(() => {
    track(
      isToday(selectedDate) ? EVENT_ACTIONS.TODAY : EVENT_ACTIONS.ANY_DATE,
      { value: selectedDate.format("MMM D YYYY") }
    );
  }, [selectedDate]);
  const handlePickerClick = () => {
    if (calendarOpened) {
      setCalendarOpened(false);
    }
  };
  const onArrowClick = (direction) => {
    setSelectedDate(dayjs(selectedDate).add(direction, "day"));
  };
  const onTodayClick = () => {
    if (live)
      setSelectedDate(dayjs());
  };
  const isToday = (date) => date.isSame(dayjs(), "day");
  return /* @__PURE__ */ jsxs(
    Flex,
    {
      className: "matches-date-picker",
      justify: "space-between",
      align: "center",
      gap: !screens.md ? 8 : 12,
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: `match-details-circle ${live ? "" : "live-button-hover"}`,
            style: {
              borderColor: token.colorLiveRed,
              backgroundColor: live ? token.colorLiveRed : token.colorBgBase,
              width: screens.md ? 56 : 48,
              height: screens.md ? 56 : 48
            },
            onClick: onLiveClick,
            children: /* @__PURE__ */ jsx("span", { children: t("live") })
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: "date-wrapper", children: [
          /* @__PURE__ */ jsx(
            "span",
            {
              className: "arrow arrow-left",
              onClick: () => onArrowClick(-1),
              children: /* @__PURE__ */ jsx(
                ArrowLeft,
                {
                  className: "stroke-base",
                  style: { width: 32, height: 32 }
                }
              )
            }
          ),
          /* @__PURE__ */ jsx(
            "span",
            {
              onClick: onTodayClick,
              className: `selected-date ${live ? "clickable" : ""}`,
              children: isToday(selectedDate) || live ? t("today") : selectedDate.format("dddd, DD MMM")
            }
          ),
          /* @__PURE__ */ jsx(
            "span",
            {
              className: "arrow arrow-right",
              onClick: () => onArrowClick(1),
              children: /* @__PURE__ */ jsx(
                ArrowRight,
                {
                  className: "stroke-base",
                  style: { width: 32, height: 32 }
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          DatePicker,
          {
            className: `match-details-circle matches-calendar ${calendarOpened ? "selected" : ""} ${!screens.md ? "mobile" : ""}`,
            style: {
              width: screens.md ? 56 : 48,
              height: screens.md ? 56 : 48
            },
            format: "MM/DD/YYYY",
            onChange: setSelectedDate,
            allowClear: false,
            suffixIcon: calendarOpened ? /* @__PURE__ */ jsx(Calendar, { className: "stroke-text-white" }) : /* @__PURE__ */ jsx(Calendar, { className: "stroke-base" }),
            onOpenChange: setCalendarOpened,
            placement: "bottomRight",
            open: calendarOpened,
            onClick: handlePickerClick
          }
        )
      ]
    }
  );
};
var stdin_default = memo(MatchesDatePicker);
export {
  stdin_default as default
};
